import type { HTMLAttributes } from 'react';
import { useState } from 'react';
import PersonIcon from '../assets/icons/person.svg?react';
import { cn } from '../utils/className';

interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  src?: string;
  alt?: string;
}

export function Avatar({ src, alt = 'Avatar', className, ...rest }: AvatarProps) {
  const [imageError, setImageError] = useState(false);

  const showFallback = !src || imageError;

  return (
    <div
      className={cn(
        'flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-gray-200',
        className
      )}
      {...rest}
    >
      {!showFallback && (
        <img
          src={src}
          alt={alt}
          onError={() => setImageError(true)}
          className='h-full w-full object-cover'
        />
      )}

      {showFallback && <PersonIcon className='h-6 w-6 text-gray-500' />}
    </div>
  );
}
